import { reloadForStaleChunkOnce } from './reloadForStaleChunkOnce';

/**
 * Recharge l'application quand Vite signale qu'un chunk lazy (JS/CSS) n'a pas pu être préchargé.
 *
 * Couvre le seul préchargement des dépendances (`vite:preloadError`) ; l'échec de l'`import()`
 * lui-même ne passe pas par cet événement et est traité par `lazyWithRetry`.
 */
export function installChunkReloadOnPreloadError(): void {
    window.addEventListener('vite:preloadError', (event) => {
        // Garde anti-boucle refusée = déjà rechargé récemment et le chunk manque toujours : on
        // laisse l'erreur remonter à l'ErrorBoundary plutôt que de boucler sur des reloads.
        if (reloadForStaleChunkOnce()) {
            event.preventDefault();
        }
    });
}
